import { render } from "./FormPage.vue?vue&type=template&id=22d64cbb&scoped=true&lang=pug"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"

import "./FormPage.vue?vue&type=style&index=0&id=22d64cbb&lang=scss&scoped=true"
import "./FormPage.vue?vue&type=style&index=1&id=22d64cbb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d64cbb"]])

export default __exports__